import React, { useState, useEffect } from "react";
import { PlusCircle } from "react-feather";
import { useForm, FormProvider } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { yupResolver } from "@hookform/resolvers/yup";
import { format, isDate } from "date-fns";
import { useNavigate } from "react-router-dom";
import { all_routes } from "Router/all_routes";
import ToastNotification from "Components/UI/ToastNotification";
import { Link } from "react-router-dom";
import { useGetAllEmployeeLeaveQuery } from "AppQuries/leave/get-employee-leaves";
import Error404 from "MainPages/ErrorPages/error404";
import LoadingSpinner from "Components/UI/LoadingSpinner";
const tabNames = ["Requested Leaves", "Approved Leaves", "Rejected Leaves"];
import Table from "core/pagination/datatable";
import TableTop from "Components/UI/TableTop";
import { useTableSearch } from "core/Operations/useTableSearch";
import Swal from "sweetalert2";
import { useUpdateEmployeeLeave } from "AppQuries/leave/employee-leave";
import Can from "core/Operations/Can";
import { accessCodes } from "core/json/accessCode";
const EmployeeLeave = () => {
  const userData = useSelector(loggedInUser);
  const navigate = useNavigate();
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const { mutate: updateLeave, isPending } = useUpdateEmployeeLeave();

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };
  const { data, isFetching, isError, error, refetch } =
    useGetAllEmployeeLeaveQuery({
      companyCode: userData?.companyCode,
      locationCode: userData?.selectedLocationCode,
      userId: userData?.userID,
      isAllCompanies: userData?.isAllCompanies,
      selectedCompanyCode: userData?.selectedCompanyCode,
    });
  const leaveData = data?.data.map((d, _id) => ({
    id: _id + 1,
    ...d,
  }));
  const [message, setMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);

  const carryForwardHandler = (id) => {
    Swal.fire({
      title: "Carry Forward To Next Year?",
      text: "Are you sure to leave carry forward to next year",
      type: "warning",
      showCancelButton: !0,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Approve it!",
      confirmButtonClass: "btn btn-primary",
      cancelButtonClass: "btn btn-danger ml-1",
      buttonsStyling: 1,
    }).then(function (t) {
      if (t.isConfirmed) {
        let selectedLeave = leaveData?.find((d) => d.id === id);
        console.log(selectedLeave);
        delete selectedLeave.id;
        selectedLeave = {
          ...selectedLeave,
          modifyUser: userData.userName,
          leaveYear: Number(selectedLeave.leaveYear),
          // locationCode : userData?.locationCode,
          modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
            new Date(),
            "HH:mm:ss.SSS",
          )}Z`,
        };

        updateLeave(selectedLeave, {
          onSuccess: (data) => {
            console.log(data);
            if (data) {
              refetch();
              Swal.fire({
                type: "success",
                title: "Leave Carry Forwarded !",
                text: "Leave Carry Forwarded Successfully..",
                confirmButtonClass: "btn btn-success",
              });
            } else {
              Swal.fire({
                title: "Warning!",
                text: data[0]?.errorMessage,
                type: "warning",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Ok",
                confirmButtonClass: "btn btn-primary",
                okButtonClass: "",
                buttonsStyling: 1,
              });
            }
          },
          onError: (error) => {
            let message = error.message || "Something went wrong.";
            Swal.fire({
              title: "Warning!",
              text: message,
              type: "warning",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Ok",
              confirmButtonClass: "btn btn-primary",
              okButtonClass: "",
              buttonsStyling: 1,
            });
          },
        });
      }
    });
  };

  if (isError) {
    <Error404 error={error} />;
  }

  if (isFetching || isPending) {
    <LoadingSpinner />;
  }

  const columns = [
    {
      title: "S.No",
      dataIndex: "id",
      sorter: (a, b) => a.id.length - b.id.length,
    },
    {
      title: "Emp Code",
      dataIndex: "uniqueID",
      sorter: (a, b) => a.uniqueID.length - b.uniqueID.length,
    },

    {
      title: "Emp Name",
      dataIndex: "employeeName",
      sorter: (a, b) => a.employeeName.length - b.employeeName.length,
      render: (text, record) => (
        <Link
          to={`${all_routes.employee}${all_routes.employee_view}/${record.employeeCode}`}
        >
          {text}
        </Link>
      ),
    },

    {
      title: "Leave Name",
      dataIndex: "leaveName",
      sorter: (a, b) => a.leaveName.length - b.leaveName.length,
    },

    {
      title: "Leave Year",
      dataIndex: "leaveYear",
      sorter: (a, b) => a.leaveYear.length - b.leaveYear.length,
    },
    {
      title: "NoOf Alloted Days",
      dataIndex: "noOfAllotedDays",
      sorter: (a, b) => a.noOfAllotedDays.length - b.noOfAllotedDays.length,
    },
    {
      title: "Leave Taken",
      dataIndex: "leaveTaken",
      sorter: (a, b) => a.leaveTaken.length - b.leaveTaken.length,
    },
    {
      title: "Balance Leave Days",
      dataIndex: "balanceLeaveDays",
      sorter: (a, b) => a.balanceLeaveDays.length - b.balanceLeaveDays.length,
    },
    {
      title: "Action",
      render: (text, record) => (
        <>
          <>
            <button
              className="btn btn-primary"
              onClick={() => carryForwardHandler(record.id)}
            >
              Carry Forward
            </button>
          </>
        </>
      ),
    },
  ];

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    leaveData,
    searchColumns,
  );

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowErrorToast(false);
      setShowSuccessToast(false);
    }, 6000);
    return () => clearTimeout(timeoutId);
  }, [showErrorToast, showSuccessToast]);

  return (
    <div>
      <div className="toast-container position-fixed top-0 end-0 p-3">
        <ToastNotification
          showSuccessToast={showSuccessToast}
          showErrorToast={showErrorToast}
          message={message}
        />
      </div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Leave Management</h4>
                <h6>Manage employees leaves</h6>
              </div>
            </div>
            {!userData?.isAllCompanies && (
              <div className="page-btn">
                <Can
                  accessModule={accessCodes.leave_adjustment}
                  accessCode={accessCodes.leave_employee_records}
                  accessType="haveAdd"
                >
                  <Link
                    to={`${all_routes.leave}${all_routes.apply_leave}`}
                    className="btn btn-primary"
                  >
                    <PlusCircle className="me-2" />
                    Apply Leave
                  </Link>
                </Can>
              </div>
            )}

            <div className="page-btn">
              <Link
                to={`${all_routes.leave}${all_routes.employee_leave2}`}
                className="btn btn-primary"
              >
                <PlusCircle className="me-2" />
                Second Secreen
              </Link>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card border-0">
                <div className="card-body">
                  <TableTop
                    onSearch={setSearchValue}
                    toggleFilterVisibility={toggleFilterVisibility}
                    isFilterVisible={isFilterVisible}
                  />

                  <div className="table-responsive">
                    <Table
                      className="table  datanew"
                      columns={columns}
                      dataSource={filteredData}
                      pagination={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeLeave;
